<template lang="pug">
  div
    .main
      .config-form-wrapper.row
        .config-form.col-md-6.col-lg-5.col-xl-4
          h2.title {{title}}
          br
          SmartForm(
            v-if="hasColumns"
            :formList="formList"
            :formLabelWidth=160
            :columns="columns"
            :values="formValues")
</template>

<script>
import SmartForm from '@/components/SmartForm'
import { fetchCreate, fetchRelation } from '@/utils/api'
import { expire } from '@/utils/auth'

export default {
  name: 'systemSetting',
  components: {
    SmartForm
  },
  data () {
    const that = this
    return {
      title: '系统设置',
      isLoading: false,
      isRelation: false,
      hasColumns: true,
      resource: '/dock/interfaceConfig',
      filterByAlways: [],
      relationList: [],
      formList: [],
      formValues: {
        manufacturer: {
          dockTypeId: 'common',
          manufacturerId: 99999,
          packageVersion: '',
          packageName: '',
          packagePath: ''
        },
        setHttp: {
          dockTypeId: 'http',
          url: ''
        }
      },
      manuButtonList: [{
        name: 'submit',
        label: '保存',
        validate: true,
        funcProps: {
          el: this
        },
        func: (data, props) => {
          const formValue = this.formValue
          fetchCreate({
            resource: that.resource,
            data: formValue
          }).then(data => {
            console.info('data:', data)
            if (data) {
              this.$msgbox('保存成功!')
            }
          })
        }
      }],
      columns: {
        system: {
          label: '系统',
          relation: 'system'
        },
        middlewaresAll: {
          label: '系统设置',
          relation: 'middlewaresAll'
        },
        creatorId: {
          label: '创建者'
        },
        createTime: {
          label: '创建时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        },
        updateTime: {
          label: '更新时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        }
      }
    }
  },
  created () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.getRelation()
  },
  computed: {
  },
  methods: {
    getRelation () {
      this.isLoading = true
      const columnsKey = Object.keys(this.columns)
      let relationKeys = columnsKey.filter(key => { return this.columns[key].relation })
      fetchRelation({
        params: relationKeys.join(',')
      }).then(res => {
        // console.log('relation:', res)
        this.relationList = res
        this.isRelation = true
        columnsKey.map(key => {
          const relation = this.columns[key].relation
          if (res[relation]) {
            const optionsInit = this.columns[key].optionsInit ? this.columns[key].optionsInit : []
            this.columns[key].options = [...optionsInit, ...res[relation]].map(option => {
              return {
                value: option.value !== undefined ? option.value : option.id,
                ...option
              }
            })
          }
        })
        this.$emit('getRelation', this.columns)
        // this.isLoading = false
        console.info('columns:', this.columns)
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.config-form-wrapper
  margin: 40px
.config-form
  margin: 0 auto
  .title
    padding-left: 140px
</style>



// WEBPACK FOOTER //
// SystemSetting.vue?5d0511b8